import { createI18n } from "vue-i18n";
import en from "./lang/en.json";
import vi from "./lang/vi.json";

const messages = {
    en: en,
    vi: vi,
};

const numberFormats = {
    "vi-VN": {
        currency: {
            style: "currency",
            currency: "VND",
            notation: "standard",
        },
        decimal: {
            style: "decimal",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        },
        percent: {
            style: "percent",
            useGrouping: false,
        },
    },
};

const datetimeFormats = {};

const i18n = createI18n({
    locale: "vi",
    globalInjection: true,
    messages: messages,
    numberFormats: numberFormats,
    datetimeFormats: datetimeFormats,
    legacy: false,
});

export default i18n;
